import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { runInAction } from 'mobx';
import UsersStore from 'Stores/usersStore';
import 'Styles/usersView/deviceInfo.scss';
import ListBox from 'Components/Common/listBox';
import Helper from 'Utils/Helper';

/**
 * @typedef {object} props
 * @property {WebUser} user
 * @extends {Component<props>}
 */
class NewDevice extends Component {

    /** @param {props} props */
    constructor(props) {
        super(props);
    }

    get newDevice() {
        return UsersStore.GetUsersDevicesLoadingState(this.props.user.lid).newDevice;
    }

    SetDeviceCode(val) {
        runInAction(() => this.newDevice.code = val.replaceAll(" ", ""));
    }

    SetRandomDeviceCode() {
        let val = Helper.GeneratePassword();
        this.SetDeviceCode(val);
    }

    GetDeviceCode() {
        let ret = this.newDevice.code;
        return ret ? ret : "";
    }

    SetOs(val) {
        runInAction(() => this.newDevice.os = val);
    }

    GetOs() {
        let ret = this.newDevice.os;
        return ret ? ret : "";
    }

    IsLoading() {
        return this.newDevice.adding == true;
    }

    render() {
        const addButtonDisabledClass =
            (this.GetOs() == ""
                ||
                this.GetDeviceCode() == ''
            )
                ? ' disabled' : '';
        const fullComponentDisabledClass = this.IsLoading() ? ' disabled' : '';

        var canSelectOs = UsersStore.deviceTypes.length > 1;
        var firstOsKey = UsersStore.deviceTypes.find(_ => _)?.key;
        var firstOsValue = UsersStore.deviceTypes.find(_ => _)?.value;

        if (canSelectOs == false && this.GetOs() != firstOsKey)
            this.SetOs(firstOsKey);

        return (
            <div className={"full-device-info new-device" + fullComponentDisabledClass}>
                <div className="device-info">
                    <div className="device-setting-information"
                        style={{ marginRight: "0px" }}>
                        <div className="device-setting-title">Код устройства:</div>
                        <input id={"device_code_" + this.props.userId}
                            className="device-setting-value"
                            onChange={(e) => this.SetDeviceCode(e.target.value)}
                            value={this.GetDeviceCode()}
                        />
                        <button
                            className={"device-info-right-button "}
                            onClick={() => this.SetRandomDeviceCode()}>
                            Сгенерировать
                        </button>
                    </div>
                    <div className="device-setting-information-without-right-container">
                        <span className="device-setting-title">Операционная система:</span>
                        <span className="device-type-value device-setting-value"
                            style={{ display: canSelectOs ? "none" : null }}>
                            {firstOsValue}
                        </span>
                        <ListBox
                            style={{ display: canSelectOs ? null : "none" }}
                            values={UsersStore.deviceTypes}
                            selectedItem={this.GetOs()}
                            onSelectedItemChanged={osKey => this.SetOs(osKey)} />
                    </div>
                    <div className="device-setting-information-without-right-container">
                        <button className={"green-button add-device-button" + addButtonDisabledClass}
                            onClick={() =>
                                UsersStore.AddDevice(
                                    this.props.user,
                                    this.GetDeviceCode(),
                                    this.GetOs()
                                    )
                            }>
                            Добавить устройство
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default observer(NewDevice);